import { jsx as _jsx } from "react/jsx-runtime";
import { CloseIcon, InfoIcon, TickIcon, WarningIcon } from '@bnb-chain/icons';
export const STATUSES = ['info', 'success', 'warning', 'danger'];
export const STATUSES_TO_COLOR_SCHEME = {
    info: 'primary',
    success: 'success',
    warning: 'warning',
    danger: 'danger',
};
export const STATUSES_TO_ICON = {
    info: _jsx(InfoIcon, {}),
    success: _jsx(TickIcon, {}),
    warning: _jsx(WarningIcon, {}),
    danger: _jsx(CloseIcon, {}),
};
